/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { select, put, takeLatest } from 'redux-saga/effects';
import * as T from '../actions';
import { isSearching, sessionListTab } from '../data/prefabs';

/**
 * Doing a quick toggle since the search saga has a debounce.
 * As soon as I start typing, let's show loading.
 */

export function* handleSearchSessions() {
  const sessionListTabIndex = yield select(sessionListTab.value);
  if (sessionListTabIndex === 0) {
    yield put(isSearching.turnOnAction);
  }
}

export default function* watchSearchSessionsSaga() {
  yield takeLatest(T.SEARCH_SESSIONS, handleSearchSessions);
}
